import {TSSerializable} from '../../models/TSSerializable';
export default class TSAuthLoginElement implements TSSerializable<TSAuthLoginElement> {

    private _username?: string;  //entspricht email
    private _password?: string;

    constructor(username?: string, password?: string) {
        this._username = username;
        this._password = password;
    }

    public get username(): string | undefined {
        return this._username;
    }

    public set username(value: string | undefined) {
        this._username = value;
    }

    public get password(): string | undefined {
        return this._password;
    }

    public set password(value: string | undefined) {
        this._password = value;
    }

    public deserialize(restObject: any): TSAuthLoginElement {
        this._username = restObject.username;
        this._password = restObject.password;

        return this;
    }

    public serialize(restObject: any): any {
        restObject.username = this.username;
        restObject.password = this.password;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/model/TSAuthLoginElement.ts